/**
 * Distribution surface keys (CT-4206) — the downstream surfaces an integration
 * can be exposed to, in table/panel column order. Single source of truth shared
 * by the table, the settings panel, and the summary-stat computation so a
 * surface added or reordered later changes in exactly one place.
 */
export const SURFACE_KEYS = ['data_studio', 'agent_studio', 'workflows', 'widgets', 'assistant'];
